export interface recalculationProps {
    agentNumber?: string;
    recalcutionAssoTab?: any;
    inputScorecardVersion?: number;
    scoreCardRoleIdValue: number;
    scoreCardWindowStatus?: any;
    agentName?: string;
    inputMonth: number;
    inputYear: number;
}

export interface recalculationModel {
    scorecardId?: number;
    year?: number;
    month?: number;
    employeeNumber?: string;
    calculationRequestTypeId?: number;
    calculationRequestStatusId?: number;
    requestBy?: string;
}

export const proceedRecalculation = (type: string, windowStatus: number) => {
    if (type === 'scorecard' && (windowStatus === 1 || windowStatus === 8)) {
        return true;
    } else if (type === 'agent' && (windowStatus === 1 || windowStatus === 2 || windowStatus === 8)) {
        return true;
    } else return false;
};
